interface CreateRoomModalActionsProps {
  isLoading: boolean;
  isSubmitDisabled: boolean;
  onCancel: () => void;
}

/**
 * Footer actions for the create room modal.
 */
export function CreateRoomModalActions({
  isLoading,
  isSubmitDisabled,
  onCancel,
}: CreateRoomModalActionsProps) {
  return (
    <div className="flex gap-3 pt-2">
      <button
        type="button"
        onClick={onCancel}
        className="flex-1 px-4 py-2.5 bg-[#252525] hover:bg-[#2f2f2f] border border-border text-white rounded-lg font-medium transition-colors disabled:opacity-50"
        disabled={isLoading}
      >
        Cancel
      </button>
      <button
        type="submit"
        className="flex-1 px-4 py-2.5 bg-accent hover:bg-accent-hover text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={isLoading || isSubmitDisabled}
      >
        {isLoading ? (
          <>
            <svg
              className="animate-spin w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
              />
            </svg>
            Creating...
          </>
        ) : (
          'Create Room'
        )}
      </button>
    </div>
  );
}
